import getDomain from '../PaymentMode/Components/getDomain';
import { generateSecret, decryptAesCbc } from '../../utils/cryptoLegacy';

async function loadGlomoSdk(scriptUrl) {
  // Try runtime dynamic import to avoid bundler/static analysis issues
  try {
    // eslint-disable-next-line no-new-func
    const dynamicImport = new Function('u', 'return import(u)');
    const mod = await dynamicImport(scriptUrl);
    const Api = mod?.GlomoCheckoutApi || mod?.default;
    if (Api) return Api;
  } catch (_) {
    // ignore and try module-injection fallback
  }
  // Fallback: inject a module that hoists API on window
  try {
    if (typeof window !== 'undefined' && window.GlomoCheckoutApi) {
      return window.GlomoCheckoutApi;
    }
    const done = () =>
      new Promise((resolve, reject) => {
        const checkReady = () => {
          if (window.GlomoCheckoutApi) resolve(window.GlomoCheckoutApi);
          else reject(new Error('Unable to load GlomoPay SDK.'));
        };
        setTimeout(checkReady, 0);
      });
    const moduleCode =
      `import * as m from '${scriptUrl}'; window.GlomoCheckoutApi = m.GlomoCheckoutApi || m.default;`;
    const blob = new Blob([moduleCode], { type: 'text/javascript' });
    const blobUrl = URL.createObjectURL(blob);
    const script = document.createElement('script');
    script.type = 'module';
    script.src = blobUrl;
    script.async = true;
    script.onload = () => {
      URL.revokeObjectURL(blobUrl);
    };
    script.onerror = () => {
      URL.revokeObjectURL(blobUrl);
    };
    document.head.appendChild(script);
    return await done();
  } catch (e) {
    throw new Error('Unable to load GlomoPay SDK.');
  }
}

export async function startGlomopayCheckout(apiData) {
  if (!apiData) {
    throw new Error('Missing apiData for GlomoPay.');
  }

  debugger;

  const encOrderId = String(apiData.orderId || '');
  if (!encOrderId) {
    throw new Error('Missing GlomoPay orderId.');
  }

  let decOrderId = encOrderId;
  let encPublicKey = String(apiData.paymentKey);
  let publicKey = encPublicKey;
  try {
    const secret = generateSecret(String(apiData.orderNo));
    decOrderId = decryptAesCbc(decodeURIComponent(encOrderId), secret);
    publicKey = decryptAesCbc(decodeURIComponent(encPublicKey), secret);
  } catch {
   throw new Error('Unable to load GlomoPay SDK.');
  }

  // Build callback URL using decrypted orderId
  const callbackUrl = decodeURIComponent(apiData.callbackUrl);
  const cancelPaymentUrl = apiData.cancelPaymentUrl
    ? decodeURIComponent(apiData.cancelPaymentUrl)
    : '';

  // Load SDK using runtime dynamic import with safe fallbacks
  const GlomoCheckoutApi = await loadGlomoSdk('https://glomopay-checkout-sdk.web.app/index.js');
  if (!GlomoCheckoutApi) {
    throw new Error('Unable to load GlomoPay SDK.');
  }

  // Debug logs before initiating checkout redirect
  // Safe to log; contains no sensitive secrets
  console.log('Glomopay orderId:', decOrderId);
  console.log('Glomopay callbackUrl:', callbackUrl);
  console.log('Glomopay cancelPaymentUrl:', cancelPaymentUrl);

  const checkout = new GlomoCheckoutApi({
    orderId: decOrderId,
    publicKey,
    callbackUrl,
  });

  checkout?.on?.('payment.success', () => {});
  checkout?.on?.('payment.failure', () => {});
  checkout?.on?.('checkout.closed', () => {
    if (cancelPaymentUrl) {
      window.location.assign(cancelPaymentUrl);
    }
  });
  try {
    await checkout.open();
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('GlomoPay checkout failed to open:', err);
    throw new Error('Unable to start GlomoPay checkout.');
  }
}

export default startGlomopayCheckout;


